import React, { Component } from 'react';
import './Toolbar.css';

import { cloneDeep } from 'lodash';

import { observer, inject } from 'mobx-react';
import Search from './Search';
import Export from './Export';
import Filters from './Filters';
import FiltersButton from './FiltersButton';

@inject('translationsStore', 'carsStore', 'filterStore')
@observer
export default class Toolbar extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.FiltersRef = React.createRef();
    this.SearchRef = React.createRef();
  }

  componentDidMount() {
    //wrappedInstance because the component is wrapped by the mobx injector
    this.FiltersInstace = this.FiltersRef.current.wrappedInstance;
    this.SearchInstance = this.SearchRef.current.wrappedInstance;
  }


  resetFilters = () => {
    const { filterStore } = this.props;
    filterStore.reset();
    this.FiltersRef.current.wrappedInstance.reset();
  };

  search(result) {
    this.resetFilters();
    const filtered = this.state.cars
      .filter(car => result.map(item => parseInt(item.ref, 10)).includes(parseInt(car.id, 10)))
      .map(car => Object.assign(car, { score: result.find(item => parseInt(item.ref, 10) === parseInt(car.id, 10)).score }))
      .sort((a, b) => b.score - a.score);

    this.setState({ filtered });
  }

  cancelSearch() {
    const filtered = cloneDeep(this.state.cars);
    this.setState({ filtered });
  }

  render() {
    const { carsStore } = this.props;

    return (
      <div className="Toolbar">
        <Filters ref={this.FiltersRef} cars={carsStore.filtered} />
        <span className="searchSummary">
          <Search ref={this.SearchRef} onSearch={this.search.bind(this)} onCancel={this.cancelSearch.bind(this)} />
        </span>
        <span className="filteredSummary">
          <FiltersButton onFiltersClick={() => this.FiltersInstace.toggle()} onResetClick={this.resetFilters} />
          <Export />
        </span>
      </div>
    );
  }
}
